import { PeriodsAgo } from "../@types/custom";

function getDateInThePast(daysBefore: number) {
  return new Date(new Date().setDate(new Date().getDate() - daysBefore));
}

export const dateWeekAgo = getDateInThePast(7);
export const dateMonthAgo = getDateInThePast(30);
export const dateThreeMonthsAgo = getDateInThePast(30 * 3);
export const dateSixMonthsAgo = getDateInThePast(30 * 6);
export const dateYearAgo = getDateInThePast(365);
export const dateThreeYearsAgo = getDateInThePast(365 * 3);

export const PERIODS_AGO_MAP = {
  [PeriodsAgo.week]: dateWeekAgo,
  [PeriodsAgo.month]: dateMonthAgo,
  [PeriodsAgo.threeMonths]: dateThreeMonthsAgo,
  [PeriodsAgo.sixMonths]: dateSixMonthsAgo,
  [PeriodsAgo.year]: dateYearAgo,
  [PeriodsAgo.threeYears]: dateThreeYearsAgo
};

export function isInDateRangeFrom(date: string, periodFrom: Date) {
  return new Date(date) >= periodFrom;
}
